// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__-lOMY","addWidgetButton":"Header_addWidgetButton__3Bj2t","dashboardTabs":"Header_dashboardTabs__z_ZSe","active":"Header_active__ozkPy"};